// REA-CI/screens/legal/TermsOfService.tsx


import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';

const TermsOfService = () => (
  <ScrollView style={styles.container}>
    <Text style={styles.header}>Terms of Service</Text>
    <Text style={styles.body}>
      Welcome to REA! By using our platform, you agree to these Terms of Service. Please read them carefully.
    </Text>

    <Text style={styles.subheader}>1. Use of the Platform</Text>
    <Text style={styles.body}>
      REA is designed to connect buyers and sellers in the real estate market. You agree to use the platform for its intended purpose and comply with all applicable laws.
    </Text>

    <Text style={styles.subheader}>2. Account Responsibilities</Text>
    <Text style={styles.body}>
      You are responsible for maintaining the confidentiality of your account credentials and all activities conducted under your account.
    </Text>

    <Text style={styles.subheader}>3. Posting Properties</Text>
    <Text style={styles.body}>
      Sellers must provide accurate and truthful information. False or misleading listings are prohibited. Verification is required before listing properties.
    </Text>

    <Text style={styles.subheader}>4. Limitation of Liability</Text>
    <Text style={styles.body}>
      REA is not responsible for the content of property listings or transactions between users. We act as a platform to facilitate connections.
    </Text>

    <Text style={styles.subheader}>5. Changes to Terms</Text>
    <Text style={styles.body}>
      We may update these Terms of Service from time to time. Continued use of the platform indicates your acceptance of the updated terms.
    </Text>
  </ScrollView>
);

const styles = StyleSheet.create({
  container: { padding: 20 },
  header: { fontSize: 24, fontWeight: 'bold', marginBottom: 10 },
  subheader: { fontSize: 18, fontWeight: '600', marginTop: 15 },
  body: { fontSize: 14, marginTop: 5, lineHeight: 20 },
});

export default TermsOfService;
